export default __webpack_public_path__ + "media/images/icons/loading-0a8f1e44f98a55fe4657673a3deb4803.svg";